import React, { useState } from 'react';
import '../../../entrydoor.css';

const GlassDividers = ({ value, label = 'Glass Dividers:', childs = [], onChange, disabled = false }) => { // Set default value for childs
    const [selectedGlassDividers, setSelectedGlassDividers] = useState(value || "None");

    const handleGlassDividersChange = (e) => {
        const newValue = e.target.value;
        setSelectedGlassDividers(newValue);
        onChange(e.target.value);

        // Dynamically fetch and modify styles for dependent controls if any exist
        if (Array.isArray(childs) && childs.length > 0) {
            childs.forEach((childId) => {
                const element = document.getElementById(childId);
                if (element) {
                    console.log("element ID: ", element.id)
                    element.style.display = newValue === "Grills" ? "block" : "none";
                    const label = element.previousElementSibling; // Fetch the label, if present
                    if (label) {
                        label.style.display = newValue === "Grills" ? "block" : "none";
                    }
                }
            });
        }
    };

    return (
        <div className="a-container">
            <label disabled={disabled} htmlFor="GlassDividers">{label}</label>
            <select
                disabled={disabled}
                id="GlassDividers"
                value={selectedGlassDividers}
                onChange={handleGlassDividersChange}
            >
                <option value='None'>{selectedGlassDividers === 'None' ? 'None ✔' : 'None'}</option>
                <option value='Grills'>{selectedGlassDividers === 'Grills' ? 'Grills ✔' : 'Grills'}</option>
            </select>
        </div>
    );
};

export default GlassDividers;
